import React from "react";
import { FormattedMessage } from "react-intl";

interface ShowMoreLessButtonProps {
  navigationNodeId: number;
  showMoreEvents: boolean;
  showLoading: boolean;
  handleShowMoreEvents: () => void;
}

const ShowMoreLessButton: React.FC<ShowMoreLessButtonProps> = ({
  navigationNodeId,
  showMoreEvents,
  showLoading,
  handleShowMoreEvents,
}) => {
  const showMoreOrLess = navigationNodeId && showMoreEvents ? "less" : "more";
  const loadingClass = showLoading ? "disabled" : "";

  return (
    <div
      className={`collapsible__show-${showMoreOrLess} ${loadingClass}`}
      onClick={handleShowMoreEvents}
    >
      {loadingClass ? (
        <FormattedMessage tagName="span" id={`competition-expanded-loading`} />
      ) : (
        <FormattedMessage
          tagName="span"
          id={`events-screen-show-${showMoreOrLess}`}
        />
      )}
    </div>
  );
};

export default ShowMoreLessButton;
